import Vue from 'vue';
import Vuex from 'vuex';
import VueResource from 'vue-resource';

import uniqueIDs from '@/mixins/unique-ids';

import accelerator from "./store/accelerator";
import analytics from "./store/analytics";
import assets from "./store/assets";
import board from "./store/board";
import cats from "./store/cats";
import config from "./store/config";
import cycle from "./store/cycle";
import food from "./store/food";
import penalty from "./store/penalty";
import score from "./store/score";
import sound from "./store/sound";
import spawner from "./store/spawner";
import timer from "./store/timer";
import tutorial from "./store/tutorial";
import views from "./store/views";

Vue.use(VueResource);
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		newComponentID: 0,
		gameOver: false,
	},
	actions: {
		generateID(context) {
			context.commit("incrementID");
		},
	},
	mutations: {
		incrementID(state) {
			state.newComponentID += 1;
		},
		endGame(state) {
			state.gameOver = true;
		},
	},
	modules: {
		accelerator,
		analytics,
		assets,
		board,
		cats,
		config,
		cycle,
		food,
		penalty,
		score,
		sound,
		spawner,
		timer,
		tutorial,
		views,
	},
});

Vue.mixin(uniqueIDs);



// WEBPACK FOOTER //
// ./src/store.js